document.addEventListener('DOMContentLoaded', () => {
    // タブとコンテンツの要素を取得する
    const tabBtns = document.querySelectorAll('.size-chart__gender__tab__tablinks');
    const tabContents = document.querySelectorAll('.size-chart__table__container');
  
    const womenAnchor = document.querySelector('.size-chart__anchor__list.women');
    const menAnchor = document.querySelector('.size-chart__anchor__list.men');
  
    // タブとコンテンツをアクティブ化する関数
    const activateTabs = tabIndexArray => {
      tabBtns.forEach((btn, index) => {
        // タブのアクティブ状態を切り替える
        const isActiveTab = tabIndexArray.includes(index);
        btn.classList.toggle('actived', isActiveTab);
        // コンテンツのアクティブ状態を切り替える
        tabContents[index].classList.toggle('actived', isActiveTab);
      });
  
      // ページ内遷移のisActiveクラスを切り替える
      if (tabIndexArray.includes(0) || tabIndexArray.includes(2)) {
        womenAnchor.classList.add('isActive');
        menAnchor.classList.remove('isActive');
      } else {
        womenAnchor.classList.remove('isActive');
        menAnchor.classList.add('isActive');
      }
    };
  
    // タブがクリックされたときの処理
    tabBtns.forEach((btn, index) => {
      btn.addEventListener('click', () => {
        // PCとSPで同じDOMが存在するため、アクティブ化するタブとコンテンツのインデックスを決定する
        const activeTabIndexArray = index === 0 || index === 2 ? [0, 2] : [1, 3];
        // タブとコンテンツをアクティブ化する
        activateTabs(activeTabIndexArray);
      });
    });
  
    const sizeTabBtns = document.querySelectorAll('.productDetail__info__size__item');
    const sizeTabContents = document.querySelectorAll('.productDetail__size__tab__content');
  
    const activateSizeTabs = tabIndexArray => {
      sizeTabBtns.forEach((btn, index) => {
        const isActiveTab = tabIndexArray.includes(index);
        btn.classList.toggle('actived', isActiveTab);
        sizeTabContents[index].classList.toggle('actived', isActiveTab);
      });
    };
  
    sizeTabBtns.forEach((btn, index) => {
      btn.addEventListener('click', () => {
        const targetIndex = index + sizeTabBtns.length / 2;
        if (targetIndex < sizeTabBtns.length) {
          console.log('pc');
          activateSizeTabs([index, targetIndex]);
        } else {
          console.log('sp');
          activateSizeTabs([targetIndex - sizeTabBtns.length, index]);
        }
      });
    });
  
    // 初期状態として最初のタブをアクティブにする
    activateTabs([0, 2]);
    activateSizeTabs([0, sizeTabBtns.length / 2]);
  
    // ページ内遷移の処理
    const buttons = document.querySelectorAll('.size-chart__anchor__btn');
    buttons.forEach(function (button) {
      button.addEventListener('click', function (event) {
        let anchor = button.getAttribute('data-anchor');
  
        // ビューポートの幅が749px以下の場合、SPと判断
        if (window.innerWidth <= 768) {
          anchor += '_sp';
        }
  
        // 遷移先の要素を取得
        const targetElement = document.querySelector(
          `.size-chart__table__brand__name[data-anchor="${anchor}"]`
        );
  
        // 該当要素が存在する場合、その位置までスクロール
        if (targetElement) {
          const topPosition = targetElement.getBoundingClientRect().top + window.pageYOffset - 50;
          window.scrollTo({ top: topPosition, behavior: 'smooth' });
        }
      });
    });
  
    //テーブルヘッダー固定
    const womenTops = document.querySelector('#sizeChartTable__header__women');
    const menTops = document.querySelector('#sizeChartTable__header__men__top');
    const menPants = document.querySelector('#sizeChartTable__header__men__bottom');
    // console.log('womenTops', womenTops);
  
    window.addEventListener('scroll', () => {
      console.log("window.scrollY", window.scrollY);
      const scrollTop = window.scrollY;
      if (window.scrollY <= 303) {
        menTops.classList.remove('fixed');
        womenTops.classList.remove('fixed');
      }
      if (window.scrollY >= 304) {
        menTops.classList.add('fixed');
        womenTops.classList.add('fixed');
      } else {
        womenTops.classList.remove('fixed');
        menTops.classList.remove('fixed');
      }
      if (window.scrollY >= 828) {
        // menTops.classList.remove('fixed');
        menPants.classList.add('fixed');
      } else {
        menPants.classList.remove('fixed');
      }
      if (window.scrollY >= 1800) {
        menTops.classList.remove('fixed');
        womenTops.classList.remove('fixed');
        menPants.classList.remove('fixed');
      }
    });
  
    //サイズをホバーしたときに、縦列にも背景色をつける
    const tables = document.querySelectorAll('.sizeChartTable');
  
    tables.forEach(table => {
      const items = table.querySelectorAll('.sizeChartTable__body__item');
  
      items.forEach(item => {
        const divs = item.querySelectorAll('div.sizeChartTable__body__item__sizeData');
  
        divs.forEach((div, divIndex) => {
          div.addEventListener('mouseover', () => {
            items.forEach(otherItem => {
              const otherDiv = otherItem.querySelector(`div.sizeChartTable__body__item__sizeData:nth-child(${divIndex + 2})`);
              otherDiv.classList.add('hovered');
            });
          });
  
          div.addEventListener('mouseout', () => {
            items.forEach(otherItem => {
              const otherDiv = otherItem.querySelector(`div.sizeChartTable__body__item__sizeData:nth-child(${divIndex + 2})`);
              otherDiv.classList.remove('hovered');
            });
          });
        });
      });
    });
  });